<template>
	<div class="mobjectNest">

		<template v-if="operationType === 'add' || operationType === 'edit'">
			<div class="row justify-content-between mx-0">
				<h3 class="mb-0 mt-3">{{title}}</h3>
				<base-button type="primary" class="groupfloor" simple @click="backByHistory()"><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
			</div>
			
			<!-- {{$route.query}}   -->
			<card class="">
				<div class="row" v-if="this.operationType == 'add' || (this.operationType == 'edit' && this.act ==1)">
					<div class="col-lg-8 col-12 pr-0 order-2 order-lg-1">
						
					<ReFormPrinter 
						:masFormConfig="masAllFormParams" 
						:objSaveApiMethod="currentApiFormMethod"
						:SuccessGo="SuccessGo"/>
					</div>
					<div class="col-lg-4 col-12 order-1 order-lg-2 sticky-container "> 
						
						<div class="sticky-item ">
							<!-- <h6 class="mt-3"><i class="tim-icons text-info icon-alert-circle-exc mr-2"></i>Примечание: кадастровый номер объекта заполняется в разделе "Особенности"</h6>	 -->
							<h6 class="mb-3" v-if="masErrorsToFix.length > 0"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>При сохранении объекта статус модерации изменится на "Не проверен"</h6>
							<div class="zipal-errors mb-3" v-if="this.zipalErrors!='' && this.zipalErrors!=null">
								<h4 class="text-danger"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Исправьте ошибки объекта, полученные при отправке в Zipal</h4>
								<p class="zipal-error-text">{{ this.zipalErrors }}</p>	
							</div>
							<div class="ReModeration"  v-if="masErrorsToFix.length > 0 || this.comment!=''">
								<h4 class="mr-2 mb-0">Модерация объекта</h4>
								<h4 class="text-danger" v-if="this.moderation_status_id == 3"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Исправьте ошибки для повторной модерации</h4>

								<div class="ReModerationErrors">
									<ul class="list-unstyled result-marker mb-3" v-if="this.moderation_status_id == '' || (this.moderation_status_id != 1 && this.moderation_status_id != 2)">
										<li v-for="(item,index) in masErrorsToFix" :key="index">{{ item }}</li>
									</ul>
									
									<p v-if="this.moderation_status_id == '' || (this.moderation_status_id != 1 && this.moderation_status_id != 2) && this.comment!=''"><span class="font-weight-bold"> Комментарий: </span> {{ this.comment }}</p>
									
								</div>
							</div>	
							
						</div>	
					</div>
				</div>
				<!-- <div  > кококо</div> -->
				<div v-if="this.operationType == 'edit' && (this.act ==0 || this.act ==null)"><h6 class="mt-3"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Редактирование недоступно. Объект находится в архиве.</h6></div>
			</card>
		</template>

		<template v-if="operationType == 'view'">
			<div class="row" v-if="typeof ApiData[0] != undefined">
				<ReSearchMObjBig :objData="ApiData[0]" v-on:moderate="getZipalErrors" />
			</div>
		</template>

	</div>
</template>
<script>
import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
import ReSearchMObjBig from 'src/our_modules/MarketingModule/ReSearchMObjBig.vue';
// import moModuleFilter from 'src/our_modules/MarketingModule/mo_module_filter.vue';

export default {
	name: 'mobjectnest-page',
	components: {
		ReFormPrinter,
		ReSearchMObjBig,
		// moModuleFilter,
	},
	data() {
		return {
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			bShowFilter: false,
			objGetParams: {},
			title: '',
			act: 0,
			masErrorsToFix: [],
			comment:'',
			moderation_status_id:'',
			zipalErrors: '',

		};
	},
	watch: {
		'$route' (to, from) {
			// console.log(to);
			// console.log(from);

			if(this.operationType !== 'add' && this.operationType !== 'edit'){
				this.getApiData();
			}else{
				this.currentFormConfig();
				this.getZipalErrors();
			}
		},
		
		

	},
	computed: {
		operationType(){
			//if(this.$route.params.object_id === 'add'){
			const path = this.$route.path; // Используем реактивное свойство $route.path

			if (path.includes('/add')) {
				return 'add';
			} else if (path.includes('/edit')) {
				return 'edit';
			}
			return 'view';			
			/*
			if(location.pathname.indexOf('/add') != -1){
				return 'add';
			}else if(location.pathname.indexOf('/edit') != -1){
				return 'edit';
			}
			return 'view';
			*/
		},
		currentApiFormMethod(){
			if(this.operationType == 'edit'){
				return {apiMethod:'MyObj.UPD',apiParam:{flt:{'id':this.$route.params.object_id},uData:[]}};
			} else if(this.operationType == 'add'){
				// return {apiMethod:'MyObj.INS',apiParam:{flt:{'id':-1},iData:[]}};
				let client_id = '';
				let task_id = '';
				let taskend_id = '';
				if (typeof this.$route.query.client_id != undefined) client_id = this.$route.query.client_id;
				if (typeof this.$route.query.task_id != undefined) task_id = this.$route.query.task_id;
				if (typeof this.$route.query.taskend_id != undefined) taskend_id = this.$route.query.taskend_id;
				//client_id, id (task_id   на самом деле), taskend_id
				return {apiMethod:'services.RUN_TASK',apiParam:{flt:{'id':task_id,'client_id':client_id,'taskend_id':taskend_id},uData:[]}};
			}
			return {apiMethod:'MyObj.UPD',apiParam:{flt:{'id':this.$route.params.object_id},uData:[]}};
		},
	},
	methods: {
		currentFormConfig(){
			if(this.operationType == 'edit'){
				this.$GVO.ApiCall('MyObj.GET_FORM_MODEL',{flt:{result_id:this.$route.params.object_id}})
					.then((objApi) => {
						// console.log('currentFormConfig',objApi);
						if(objApi.success){
							this.masAllFormParams = objApi.config;
							if(objApi.title){
								this.title= objApi.title;
								objApi.title && window.dispatchEvent(new CustomEvent('update-title', {
									detail: { title: objApi.title }
								})) 
							}
							if(objApi.act)
								this.act = objApi.act;
							this.getErrorsToFix();
						} else if (objApi.success == false){
							this.$GVO.showAlert('Редактирование',objApi.msg);
							// alert('зоебали');
						}
					})
					.catch(errorObjApi => console.error('errorObjApi',errorObjApi));
			} else if(this.operationType == 'add'){
				this.$GVO.ApiCall('MyObj.GET_FORM_MODEL',{flt: this.$GVO.GetAllGet()})
					.then((objApi) => {
						// console.log('form', objApi);
						if(objApi.success){
							this.masAllFormParams = objApi.config;
							if(objApi.title){
								this.title= objApi.title;
								objApi.title && window.dispatchEvent(new CustomEvent('update-title', {
									detail: { title: objApi.title }
								})) 								
							}
							if(objApi.act)
								this.act = objApi.act;
						}else if (objApi.success == false){
							this.$GVO.showAlert('Добавление',objApi.msg);
							// alert('зоебали');
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
			}
			return [];
		},
		SuccessGo(evt,data){
			// debugger;
			// console.log('SuccessGo',evt,data);
			//console.log('SuccessGo',data.data[0]);
			if(this.operationType == 'edit'){
				//this.$router.push({path: '/data/module/mo/object/'+this.$route.params.object_id}); // тут есть косяк того что компонент думает что до сих пор 'edit'
				this.$router.push({path: '/data/module/mo/object/'+this.$route.params.object_id});
				// location.href = '/data/module/mo/object/'+this.$route.params.object_id;
				
				this.Moderate();

			} else if(this.operationType == 'add'){
				if(data){
					if(data.client_id!=undefined){
						//this.$router.push({path: '/data/clients/id/'+data.client_id});
						this.$router.push({path: '/data/clients/id/'+data.client_id});
						// location.href = '/data/clients/id/'+data.client_id;
						return 
					}
					if(data.data[0] && data.data[0].client_id!=undefined){
						//this.$router.push({path: '/data/clients/id/'+data.data[0].client_id});
						this.$router.push({path: '/data/clients/id/'+data.data[0].client_id});
						// location.href = '/data/clients/id/'+data.data[0].client_id;
						return 
					}
				}
				// пытаемся найти client_id в url
				const client_id = new URL(location).searchParams.get('client_id');
				if(client_id)
					this.$router.replace({path: '/data/clients/id/'+client_id})
			}
		},
		getApiData(){
			//console.log('getApiData = MyObj.GET', this.$route.params.object_id);
			this.ApiData = [];

			this.$GVO.ApiCall('MyObj.GET',{flt:{'id':this.$route.params.object_id}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						this.ApiData[0].name && window.dispatchEvent(new CustomEvent('update-title', {
                            detail: { title: this.ApiData[0].name }
                        }))   
					}
				}else{
					this.ApiData = [];
					
				}
			}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi); });
		},
		getErrorsToFix(){
			this.masErrorsToFix=[];
			this.$GVO.ApiCall('MyObj.GET_MODERATION_ERRORS',{flt:{object_id:this.$route.params.object_id}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						// console.log('getErrorsToFix',objApi.data[0]);
						//this.masErrorsToFix = JSON.parse(this.masModeratedObjs.errors);
						if(objApi.data[0].errors && objApi.data[0].errors!=undefined && objApi.data[0].errors!='' && objApi.data[0].errors!='[]'){
							this.masErrorsToFix = JSON.parse(objApi.data[0].errors);
						}else {this.masErrorsToFix=[];}
						
						this.comment = objApi.data[0].comment;
						this.moderation_status_id = objApi.data[0].moderation_status_id;
					}
				}
			}).catch(errorObjApi => {console.error(errorObjApi); });
		},
		Moderate(){
			this.$GVO.ApiCall('MyObj.UPD_STATUS',{flt:{id:this.$route.params.object_id, moderation_status: 1, }})
			.then((objApi) => {
				if(objApi.success === true){
					//this.moderation_status_id = objApi.data[0].moderation_status_id;
				} /*else{
					alert('Не сохранилось. Возможно у вас нет прав на модерацию');
					
				}*/
			}).catch(errorObjApi => {console.error(errorObjApi); });

		},
		getZipalErrors(){
			this.zipalErrors = '';

			let SGVO=this.$GVO;
			// this.$GVO.ApiCall('MyObj.GET',{flt:{'id':this.$route.params.object_id}})
			if(this.$route.params.object_id !=undefined){
			SGVO.ApiCall("MyObj.GET",{"flt":{'id':this.$route.params.object_id,"srv_new":"1","srv_inwork":"1", fields:"id,zipal_error"}})
			// SGVO.ApiCall('MANUAL_RETRYING',{obj:'services',iData:{'service_id':this.objService.id,'client_id':this.$route.params.client_id,'BP_TASK_ID':taskData.id}})
				.then((objApi) => {
					
					if(objApi.success === true) {
						//console.log(objApi.data);
						if(objApi.data[0]){
							this.zipalErrors = objApi.data[0].zipal_error;
						}else{
							this.zipalErrors = '';
						}
						if(this.ApiData[0])
							this.ApiData[0].zipal_error = this.zipalErrors;

					}
				}).catch(errorObjApi => {
					this.zipalErrors = '';
					return console.error(errorObjApi)
				});
			}

			// this.$GVO.ApiCall('MyObj.GET',{flt:{'id':this.$route.params.object_id}})
			// .then((objApi) => {
			// 	if(objApi.success === true){
			// 		if(objApi.data.length > 0){
			// 			this.zipalErrors = objApi.data[0].zipal_error;
			// 			//console.log('this.zipalErrors ', this.zipalErrors);
			// 		}
			// 	}else{
			// 		this.zipalErrors = '';
					
			// 	}
			// }).catch(errorObjApi => {console.log(errorObjApi); });
		},
		backByHistory(){
			this.$router.back();
		},
		
	},
	mounted() {
		if(this.operationType !== 'add' && this.operationType !== 'edit'){
			this.getApiData();
		}else{
			this.currentFormConfig();
			this.getZipalErrors();
		}
	}
};
</script>
<style scoped>

.mobjectNest >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}
/* .mobjectNest >>> .form-group, .mobjectNest >>> #feature {padding-right: 38px!important;} */
.mobjectNest >>>  .sticky-container {position: relative;}
.mobjectNest >>>  .sticky-item {display: flex; flex-direction: column; position: sticky; top: 15px; z-index: 2; background: inherit;}
.mobjectNest >>>  .ReModeration {border: 1px dashed #BA54F5; border-radius: 6px; padding: 15px;}
.mobjectNest >>> .zipal-errors {margin-bottom: 15px; border: 1px dashed #F84E54; border-radius: 6px; padding: 10px; grid-gap: 10px;}
.mobjectNest >>> .zipal-error-text {white-space:pre-wrap; line-height: 0.8;}
.mobjectNest >>>  .form-options-group {width: 70%!important;}
.mobjectNest >>>  .filesContainer {height: 550px;  }
.mobjectNest >>>  .fastScrollContainer {border: 1px solid #00BF9A; padding: 25px 5px 5px 5px; border-radius: 6px;}
.mobjectNest >>>  .fastScrollSpot {display: flex;}
.mobjectNest >>> #photosPlan, .mobjectNest >>> #photosMain,  .mobjectNest >>> #photos {border: 1px dashed #01B0E0; border-radius: 6px; margin-bottom: 10px;}

.mobjectNest >>> .field-border-top{border: 1px dashed #01B0E0; border-radius: 6px 6px 0 0; padding-bottom: 10px; border-bottom-width:0px;}
.mobjectNest >>> .field-border-side{border: 1px dashed #01B0E0; padding-bottom: 10px; border-width: 0px 1px;}
.mobjectNest >>> .field-border-bottom{border: 1px dashed #01B0E0; border-radius: 0 0 6px 6px; padding-bottom: 10px; border-top-width:0px;}

@media (max-width: 1400px) {
	.mobjectNest >>>  .form-options-group {width: 100%!important;}
}

@media (max-width: 768px) {
	.mobjectNest >>>  .filesContainer {height: 480px;}
}

</style>
